// import jwtDecode from 'jwt-decode';
import axios from 'src/utils/axios';
import axiosDebug from 'src/utils/axiosDebug';
import ConfigurationService from 'src/services/configurationService';
import { deleteRequestWithAuthorization, errorHandler } from './requests';

class AuthService {
  setAxiosInterceptors = ({ onLogout }) => {
    axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response && error.response.status === 401) {
          this.setAccessToken(null);

          if (onLogout) {
            onLogout();
          }
        }

        return Promise.reject(error);
      }
    );
  };

  handleAuthentication = async hash => {
    const accessToken = this.getAccessToken();

    if (this.isValidToken(accessToken)) {
      this.setAccessToken(accessToken);
    } else if (hash) {
      const session = await this.checkSession(hash);

      if (session) {
        this.setAccessToken(session.hash);
      }
    }
  };

  loginWithEmailAndPassword = async (email, password, clientLogin = false) =>
    new Promise((resolve, reject) => {
      let dataPost;

      if (clientLogin) {
        dataPost = { CpfCnpj: email, Email: password };
      } else {
        dataPost = { NomeUsuario: email, Senha: password };
      }

      axios
        .post('/genericos/ge/login', dataPost)
        .then(response => {
          if (response.data.success) {
            const { hash, data } = response.data;

            this.setAccessToken(hash);
            ConfigurationService.loadAll();
            resolve(data);
          } else {
            const { messages } = response.data;
            reject(messages[0]);
          }
        })
        .catch(error => {
          const { status } = error?.response || 0;

          if (status === 401) {
            const { messages } = error.response.data;
            reject(messages[0]);
          }

          if (status === 500) {
            const { messages } = error.response.data;
            reject(messages[0]);
          }

          if (status === 404) {
            reject('Caminho não encontrado!');
          }

          reject('Servidor fora do ar!');
        });
    });

  loginInWithToken = () =>
    new Promise((resolve, reject) => {
      axios
        .post('/genericos/ge/sessao')
        .then(response => {
          if (response.data.success) {
            const { hash, data, tipoLogin } = response.data;

            this.setAccessToken(hash);
            ConfigurationService.loadAll();
            resolve({ ...data[0], tipoLogin });
          } else {
            const messages = errorHandler(response);
            reject(messages);
          }
        })
        .catch(error => {
          const messages = errorHandler(error);
          reject(messages);
        });
    });

  logout = () => {
    const accessToken = this.getAccessToken();
    if (accessToken) this.logoutSession(accessToken);

    this.setAccessToken(null);
    localStorage.removeItem('configuration');
    localStorage.removeItem('debugger');
    localStorage.removeItem('debugger-status');
    localStorage.removeItem('debugger-path');
    localStorage.removeItem('report-production-area');
  };

  logoutSession = accessToken =>
    new Promise((resolve, reject) => {
      return deleteRequestWithAuthorization(
        '/genericos/ge/sessao',
        accessToken,
        resolve,
        reject
      );
    });

  checkSession = accessToken =>
    axios
      .post(
        '/genericos/ge/sessao',
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then(response => {
        return response.data;
      })
      .catch(error => {
        errorHandler(error);
      });

  setAccessToken = accessToken => {
    if (accessToken) {
      localStorage.setItem('accessToken', accessToken);
      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
      axiosDebug.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    } else {
      localStorage.removeItem('accessToken');
      delete axios.defaults.headers.common.Authorization;
      delete axiosDebug.defaults.headers.common.Authorization;
    }
  };

  getAccessToken = () => localStorage.getItem('accessToken');

  isValidToken = accessToken => {
    if (!accessToken) {
      return false;
    }

    return true;
  };

  isAuthenticated = () => !!this.getAccessToken();
}

const authService = new AuthService();

export default authService;
